import React, { useCallback, useMemo } from "react";

import { useIntl } from "react-intl";

import FilterOperator from "@mapmycustomers/shared/enum/FilterOperator";
import FilterModel from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";

import RoundButton from "@app/component/RoundButton";

import useStatus from "../../QuickFilterBar/utils/useStatus";

interface Props {
  fieldName?: string;
  filter: FilterModel;
  onUpdateFilterModel: (filterModel: Partial<FilterModel>) => void;
}

const NoLocationFilter: React.FC<Props> = ({
  fieldName = "geoPoint",
  filter,
  onUpdateFilterModel,
}) => {
  const intl = useIntl();

  const expectedFilterModel = useMemo(
    () => ({ [fieldName]: { operator: FilterOperator.EMPTY, value: undefined } }),
    [fieldName]
  );
  const enabled = useStatus(expectedFilterModel, filter);

  const handleClick = useCallback(() => {
    onUpdateFilterModel({
      // toggle state: reset filter if it was enabled and vice versa
      [fieldName]: enabled ? undefined : expectedFilterModel[fieldName],
    });
  }, [enabled, expectedFilterModel, fieldName, onUpdateFilterModel]);

  return (
    <RoundButton active={enabled} onClick={handleClick}>
      {intl.formatMessage({
        id: "component.quickFilters.noLocation",
        defaultMessage: "No location",
        description: "No Location quick filter",
      })}
    </RoundButton>
  );
};

export default NoLocationFilter;
